import React, { useState, useEffect } from "react";
import {
  FaCheck,
  FaClock,
  FaPlay,
  FaHandHolding,
  FaBookOpen,
  FaStar,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import breadcrumbImage from "../../../assets/images/course/cousre.jpg";
import { Card, CardBody, CardHeader, Container } from "react-bootstrap";
import author from "../../../assets/images/course/author.jpg";
import course from "../../../assets/images/course/course-detail.png";
import { useNavigate } from "react-router-dom";

const OffLineCoursesDetail = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const [blog, setBlog] = useState();
  const [packagedata, setpackage] = useState([]);
  const [imagePath, setImagePath] = useState("");
  const courseId = localStorage.getItem("courseId");
  const navigate = useNavigate();
  const user_id = localStorage.getItem("user_id");
  useEffect(() => {
    fetchBlogDetail();
    fetchPackageDetail();
  }, [courseId]);
  const fetchBlogDetail = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/course-details`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ course_id: courseId }),
        }
      );
      const data = await response.json();
      setBlog(data.data);
      setImagePath(data.imagePath);
      if (data.status === 1) {
        setImagePath(data.imagePath);
      } else {
        console.error("Failed to load blog data");
      }
    } catch (err) {
      console.error("Error fetching blog:", err);
    }
  };
  const fetchPackageDetail = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/course-package`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ course_id: courseId }),
        }
      );
      const data = await response.json();
      setpackage(data.data);
      setImagePath(data.imagePath);
      if (data.status === 1) {
        setImagePath(data.imagePath);
      } else {
        console.error("Failed to load blog data");
      }
    } catch (err) {
      console.error("Error fetching blog:", err);
    }
  };

  const stripHTMLTags = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };
  const handleReadMore = (id) => {
    localStorage.setItem("packageId", id);
    navigate("/course-detail-subject");
  };
  const handleReadMorepay = (id) => {
    if (!user_id) {
      // setToastMessage("Please login to join the live class");
      // setShowToast(true);
      navigate("/login");
      return;
    }
    localStorage.setItem("packageId", id);
    navigate("/package-plan-list");
  };
  return (
    <>
      <section className="course">
        <div className="page_header"></div>
        <div className="rs-breadcrumbs breadcrumbs-overlay">
          <div className="breadcrumbs-img">
            <img src={breadcrumbImage} alt="Breadcrumbs info" />
          </div>
          <div className="breadcrumbs-text white-color">
            <h1 className="page-title">Off Line Courses Detail</h1>
          </div>
        </div>

        <Container>
          <div className="course_detail py-60">
            <Card className="course_content_top shadow_light">
              <div className="row">
                {/* Left Side */}
                <div className="col-lg-6">
                  {/* <div className="row">
                    <div className="col-xl-6 col-lg-12 col-sm-6">
                      <div className="author_block_card mb-16 d-flex align-items-center">
                        <div className="author_img me-3">
                          <img src={author} alt="Author" />
                        </div>
                        <div className="author_detail">
                          <h5 className="mb-1">
                            <Link to="/team-detail">Olivia White</Link>
                          </h5>
                          <p>Senior Designer</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-12 col-sm-6 mb-16">
                      <p className="mb-1">Published Date</p>
                      <span>{blog?.date || "date"}</span>
                    </div>
                  </div> */}
                  <CardBody>
                    <h2 className="mb-3">{blog?.title || "Unknown Author"}</h2>
                    <p className="mb-4">
                      {stripHTMLTags(blog?.description || "")}
                    </p>
                  </CardBody>
                </div>

                {/* Right Side */}

                <div className="col-lg-6 text-center">
                  <div className="educate-tilt">
                    {/* <img src={course} alt="Course" className="br-20 mb-4" /> */}
                    <img
                      className="br-20"
                      src={blog?.image ? `${imagePath}${blog.image}` : course}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = course;
                      }}
                      alt={blog?.title || "Course Image"}
                    />
                  </div>
                </div>
              </div>
            </Card>

            <div className="row">
              {/* Tabs Navigation */}
              <h4 className="mt-5 fw-semibold">What you'll learn</h4>
              {packagedata &&
                packagedata.map((item, index) => (
                  <div className="col-lg-4" key={index}>
                    <div className="course__card mb-24">
                      <div className="course__card__content ms-0 shadow_light">
                        <div className="course_count">{index + 1}</div>
                        <div className="left__block ps-3">
                          <img src={item.tag} alt="" className="course_tag" />
                          <h4 className="mb-4p">
                            <a className="fs-5">{item.name}</a>
                          </h4>
                          <p className="mb-4p fs-6 course_desc">
                            {" "}
                            {stripHTMLTags(item?.description || "")}
                          </p>
                          <div className="d-flex align-items-center gap-3 mt-1">
                            <button
                              onClick={() => handleReadMore(item.id)}
                              className="educate-btn sm me-2"
                            >
                              <span className="educate-btn__curve"></span>
                              Course Content <FaChevronRight />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default OffLineCoursesDetail;
